import { NotFoundComponent } from './features/routes/not-found/not-found.component';
import { NotAuthorizedComponent } from './features/routes/not-authorized/not-authorized.component';
import { PREVAILING_WAGE_SETUP_ROUTES } from '@setup/prevailing-wage-setup/prevailing-wage-routing.route';
import { LoginCallbackComponent } from './shared/components/authentication/login-callback/login-callback.component';
import { LoginSsoComponent } from './shared/components/authentication/login-sso/login-sso.component';
import { isAuthGuard } from './shared/components/authentication/guards/is-auth.guard';
import { AppRoutes } from './shared/interfaces/app-routes.interface';

export const APP_ROUTES: AppRoutes = [
  {
    path: '',
    canActivate: [isAuthGuard],
    loadComponent: () =>
      import('./features/routes/layout/layout.component').then(
        c => c.LayoutComponent
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/routes/home/home.component').then(
            c => c.HomeComponent
          ),
      },
      {
        path: 'setup',
        children: [
          {
            path: 'prevailing-wage-setup',
            loadComponent: () =>
              import(
                './features/setup/prevailing-wage-setup/prevailing-wage-setup.component'
              ).then(c => c.PrevailingWageSetupComponent),
            children: PREVAILING_WAGE_SETUP_ROUTES,
            runGuardsAndResolvers: 'always',
          },
        ],
      },
      {
        path: 'not-authorized',
        component: NotAuthorizedComponent,
      },
      {
        path: 'not-found',
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'login/success',
    component: LoginCallbackComponent,
  },
  {
    path: 'login/sso',
    component: LoginSsoComponent,
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
